// TODO: Add integration tests to cover this. https://sim.amazon.com/issues/NHE-243
/* istanbul ignore file */

/**
 * Creates a popup taking up to a given width and right justified.
 * @param url URL to open.
 * @param ezoWidthPercentage The percentage of the EZO width to the screen width.
 * @param windowPopupWidthPercentage The percentage of the screen width of the new window popup.
 */
export function createSideBySidePopup({
  url,
  ezoWidthPercentage,
  windowPopupWidthPercentage,
}: {
  url: string;
  ezoWidthPercentage: number;
  windowPopupWidthPercentage: number;
}): Window | null {
  return window.open(
    url,
    url,
    `
      popup=1,
      left=${window.screen.availWidth * ezoWidthPercentage},
      top=0,
      width=${Math.max(
        window.screen.availWidth * windowPopupWidthPercentage,
        400
      )},
      height=${window.screen.availHeight}`
  );
}

/**
 * Resizes wizard window to the given width percentage and left justifies it.
 */
export function resizeWizardForSideBySide({
  ezoWidthPercentage,
}: {
  ezoWidthPercentage: number;
}): void {
  // Resize to 1/3 width
  window.resizeTo(
    window.screen.availWidth * ezoWidthPercentage,
    window.screen.availHeight
  );

  // Move to top left corner
  window.moveTo(0, 0);
}
